import AttendType from "./AttendType";
import Member from "./Member";
import {PollItem} from "./PollItem";

class MemberPollItem {
    id: string;
    member: Member;
    pollItem: PollItem;
    attendType: AttendType;
    comment: string | null;

    constructor(id: string, member: Member, pollItem: PollItem, attendType: AttendType, comment: string | null) {
        this.id = id;
        this.member = member;
        this.pollItem = pollItem;
        this.attendType = attendType;
        this.comment = comment;
    }

    static fromJson(json: any) {
        return new MemberPollItem(
            json.id,
            Member.fromJson(json.member),
            PollItem.fromJson(json.pollItem),
            json.attendType as AttendType,
            json.comment,
        )
    }
}

export default MemberPollItem;